// extracted by mini-css-extract-plugin
module.exports = {"hidden":"infoDetailRecommend_hidden__8JxhK","textEmphasis":"infoDetailRecommend_textEmphasis__hbYGW","recommendArea":"infoDetailRecommend_recommendArea___qV2M"};